// Ответ на конкретное сообщение чата (SDBL-13).
//
// Исходное сообщение берётся из уже загруженной переписки этого же обращения: сервер отдаёт
// только replyToId, лишних запросов на историю нет. Сообщение другого обращения сюда
// попасть не может — его нет в списке, и оно покажется как недоступное.

export const REPLY_UNAVAILABLE_TEXT = 'Сообщение недоступно';
export const REPLY_ATTACHMENT_TEXT = 'Вложение';

// Плашка показывает до двух строк — остальное режет CSS. Ограничение длины лишь не даёт
// тащить в цитату многостраничный текст.
const EXCERPT_LIMIT = 200;

export function hasReply(comment) {
    return Boolean(comment && comment.replyToId);
}

export function indexCommentsById(comments) {
    const index = {};

    (comments || []).forEach((comment) => {
        index[comment.id] = comment;
    });

    return index;
}

export function commentExcerpt(comment) {
    const text = (comment?.text || '')
        .replace(/<span class='chat-text-color-blue'>|<\/span>/g, '')
        .replace(/<br\s*\/?>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    return text.length > EXCERPT_LIMIT ? text.slice(0, EXCERPT_LIMIT).trimEnd() + '…' : text;
}

export function replyPreview(source) {
    if (!source) {
        return { available: false, author: '', text: REPLY_UNAVAILABLE_TEXT, isAttachment: false };
    }

    const author = source.author?.displayName || '';
    const text = commentExcerpt(source);

    if (text) {
        return { available: true, author, text, isAttachment: false };
    }

    const isAttachment = (source.files || []).length > 0;

    return { available: true, author, text: isAttachment ? REPLY_ATTACHMENT_TEXT : '', isAttachment };
}
